import {RemoteGetWaitingPeriodUrl} from 'data/usecases/private/external-links/waiting-period/remote-get-waiting-period';
import {GetWaitingPeriodUrl} from 'domain/usecases/private/external-links/waiting-period/get-waiting-period';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetWaitingPeriodUrl = (): GetWaitingPeriodUrl =>
	new RemoteGetWaitingPeriodUrl(
		makeBFFApiUrl(ExternalLinkPoint.waitingPeriod),
		makeAuthorizeHttpClientDecorator(),
	);
